import axios from "axios";
import parser from "xml-js";

const getCentro = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  let response = await axios.get(
    window.url_api +
    "/app/zws_app_buscar_centro?matricula=" +
    (user.matricula || "-1")
  );
  response = parser.xml2json(response.data, { compact: true, spaces: 4 });
  response = JSON.parse(response);
  try {
    if (
      !response["soap-env:Envelope"]["soap-env:Body"][
        "n0:ZMM_WS_APP_BUSCAR_CENTROResponse"
      ]["T_DADOS_CENTRO"]["item"].length
    ) {
      return [
        response["soap-env:Envelope"]["soap-env:Body"][
        "n0:ZMM_WS_APP_BUSCAR_CENTROResponse"
        ]["T_DADOS_CENTRO"]["item"],
      ];
    }

    return response["soap-env:Envelope"]["soap-env:Body"][
      "n0:ZMM_WS_APP_BUSCAR_CENTROResponse"
    ]["T_DADOS_CENTRO"]["item"];
  }
  catch (e) {
    console.error(e)
    return []
  }
};

export default {
  getCentro,
};
